import { useEffect, useState } from 'react';
// import { paramCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';

// material
// import CreateClientForm from 'src/components/_dashboard/client/CreateClientForm';
import { Button, Container } from '@material-ui/core';
// eslint-disable-next-line import/no-unresolved
// import CreateClientTab from 'src/components/_dashboard/client/CreateClientTab';
// eslint-disable-next-line import/no-unresolved
import CreateClientForm from 'src/components/_dashboard/client/CreateClientForm';
// eslint-disable-next-line import/no-unresolved
import ClientList from 'src/components/_dashboard/client/ClientList';
// eslint-disable-next-line import/no-unresolved
// import CreateClientForm from 'src/components/_dashboard/client/CreateClientForm';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// eslint-disable-next-line import/no-unresolved
import ReportCards from 'src/components/_dashboard/report/ReportCards';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserList } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function Reports() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { name } = useParams();
  const { userList } = useSelector((state) => state.user);
  const isEdit = pathname.includes('edit');
  // const currentUser = userList.find((user) => paramCase(user.name) === name);

  const [createClient, setCreateClient] = useState(false);
  const cardInfo = [
    { title: 'Campaign', caption: 'history of all campaigns ' },
    { title: 'Report Name', caption: 'detailed description of reports ' },
    { title: 'Report Name', caption: 'detailed description of reports ' },
    { title: 'Report Name', caption: 'detailed description of reports ' },
    { title: 'Report Name', caption: 'detailed description of reports ' },
    { title: 'Report Name', caption: 'detailed description of reports ' },
    { title: 'Report Name', caption: 'detailed description of reports ' },
    { title: 'Report Name', caption: 'detailed description of reports ' },
    { title: 'Report Name', caption: 'detailed description of reports ' },
    { title: 'Report Name', caption: 'detailed description of reports ' },
    { title: 'Report Name', caption: 'detailed description of reports ' }
  ];
  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  return (
    <Page title="Reports | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={!isEdit ? 'Report' : 'Edit user'}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Report', href: PATH_DASHBOARD.general.reports },
            { name: createClient ? 'Report' : 'Report List' }
          ]}
          action={
            createClient ? (
              <Button
                variant="outlined"
                onClick={() => {
                  setCreateClient(!createClient);
                }}
                startIcon={<Icon icon={backFill} />}
              >
                List
              </Button>
            ) : (
              <Button
                variant="outlined"
                onClick={() => {
                  setCreateClient(!createClient);
                }}
                startIcon={<Icon icon={plusFill} />}
              >
                Report
              </Button>
            )
          }
        />
        <ReportCards cardInfo={cardInfo} />
        {/* {createClient ? <CreateClientForm /> : <ClientList />} */}
      </Container>
    </Page>
  );
}
